import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import store from "../../index";
import { toast } from "react-hot-toast";

const initialState = {
  uploadedImgName: "",
  imgStatus: "N",
  imgMsg: "",
  imgLoading: false,
  imgError: "",
};

export const imageUpload = createAsyncThunk(
  "Image/deliverychalan",
  async ({ formData }) => {
    console.log("🚀 ~ file: Imguploadreducer.js:19 ~ formData:", formData);
    const url = store.getState().globalurl.imgUploadUrl;
    //const url = store.getState().globalurl.fileUploadUrl;
    const response = await axios.post(url, formData, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: Imguploadreducer.js:26 ~ response:", response);
    return response.data;
  },
);
export const fileUpload = createAsyncThunk(
  "Image/Finance Entry",
  async ({ formData }) => {
    console.log("🚀 ~ file: Imguploadreducer.js:19 ~ formData:", formData);
    const url = store.getState().globalurl.fileUploadUrl;
    const response = await axios.post(url, formData, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: Imguploadreducer.js:26 ~ response:", response);
    return response.data;
  },
);
export const videoUpload = createAsyncThunk(
  "videoUpload/post",
  async ({ formData }) => {
    const url = store.getState().globalurl.fileUploadUrl;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: Imguploadreducer.js:26 ~ response:", response);
    return response.data;
  },
);

export const getApiSlice = createSlice({
  name: "imageApi",
  // initialState,
  initialState: {
    imgLoading: false,
    videoLoading: false,
    imgError: "",
    uploadedImgName: "",
    uploadedVideoName: "",
    imgStatus: "",
    videoStatus: "",
    imgMsg: "",
    videoMsg: "",
    Data: {},
  },
  // reducers: {
  //   pending(state) {
  //     return {
  //       ...state,
  //       imgLoading: true,
  //       imgError: false,
  //     };
  //   },
  //   errored(state, action) {
  //     return {
  //       ...state,
  //       imgLoading: false,
  //       imgError: action.payload,
  //     };
  //   },
  //   Success(state, action) {
  //     return {
  //       ...state,
  //       imgLoading: false,
  //       imgError: "",
  //       uploadedImgName: action.payload.apiResponse,
  //       imgStatus: action.payload.Status,
  //       imgMsg: action.payload.Msg,
  //     };
  //   },
  // },
  // reducers: {},

  // extraReducers: (builder) => {
  //   // IMAGE
  //   builder
  //     .addCase(fileUpload.pending, (state) => {
  //       state.imgLoading = true;
  //       state.imgError = "";
  //     })

  //     .addCase(fileUpload.fulfilled, (state, action) => {
  //       state.imgLoading = false;
  //       state.uploadedImgName = action.payload.name;
  //       state.imgStatus = action.payload.Status;
  //       state.imgMsg = action.payload.Msg;
  //     })

  //     .addCase(fileUpload.rejected, (state, action) => {
  //       state.imgLoading = false;
  //       state.imgError = action.error.message;
  //     })

  //     // VIDEO
  //     .addCase(videoUpload.pending, (state) => {
  //       state.videoLoading = true;
  //     })

  //     .addCase(videoUpload.fulfilled, (state, action) => {
  //       state.videoLoading = false;
  //       state.videoStatus = action.payload.Status;
  //       state.videoMsg = action.payload.Msg;
  //     })

  //     .addCase(videoUpload.rejected, (state, action) => {
  //       state.videoLoading = false;
  //       state.imgError = action.error.message;
  //     });
  // },
  reducers: {
    pending: () => {},

    errored: (_, action) => action.payload,

    Success: (_, action) => action.payload,
  },

  extraReducers: (builder) => {
    builder

      // ========= OLD ACTIONS =========

      .addCase(pending, (state) => {
        state.imgLoading = true;
        state.imgError = "";
      })

      .addCase(errored, (state, action) => {
        state.imgLoading = false;

        state.imgError =
          action.payload || "Something went wrong";
      })

      .addCase(Success, (state, action) => {
        state.imgLoading = false;

        state.imgError = "";

        state.uploadedImgName =
          action.payload.apiResponse;

        state.imgStatus =
          action.payload.Status;

        state.imgMsg =
          action.payload.Msg;
      })

      // ========= FILE =========

      .addCase(fileUpload.pending, (state) => {
        state.imgLoading = true;
        state.imgError = "";
      })

      .addCase(fileUpload.fulfilled, (state, action) => {
        state.imgLoading = false;

        state.uploadedImgName =
          action.payload.name;

        state.imgStatus =
          action.payload.Status;

        state.imgMsg =
          action.payload.Msg;
      })

      .addCase(fileUpload.rejected, (state, action) => {
        state.imgLoading = false;

        state.imgError =
          action.error.message;
      })

      // ========= IMAGE =========

      .addCase(imageUpload.pending, (state) => {
        state.imgLoading = true;
      })

      .addCase(imageUpload.fulfilled, (state, action) => {
        state.imgLoading = false;

        state.uploadedImgName =
          action.payload.name;

        state.imgStatus =
          action.payload.Status;

        state.imgMsg =
          action.payload.Msg;
      })

      .addCase(imageUpload.rejected, (state, action) => {
        state.imgLoading = false;

        state.imgError =
          action.error.message;
      })

      // ========= VIDEO =========

      .addCase(videoUpload.pending, (state) => {
        state.videoLoading = true;
      })

      .addCase(videoUpload.fulfilled, (state, action) => {
        state.videoLoading = false;

        state.uploadedVideoName =
          action.payload.name;

        state.videoStatus =
          action.payload.Status;

        state.videoMsg =
          action.payload.Msg;
      })

      .addCase(videoUpload.rejected, (state, action) => {
        state.videoLoading = false;

        state.imgError =
          action.error.message;
      });
  },
});

// Destructure and export the plain action creators
export const { pending, errored, Success } = getApiSlice.actions;

export default getApiSlice.reducer;

export const fnFetchImage = (AccessID, recID) => (dispatch, getState) => {
  var url = store.getState().globalurl.imageNameUpdateUrl;
  var data = {
    accessid: AccessID,
    Recordid: recID,
    Action: "get",
    ImageName: "",
  };

  console.log(data);
  dispatch(pending());
  axios
    .post(url, data, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    })

    .then((response) => {
      console.log("response data" + JSON.stringify(response.data));
      var apidata = response.data;

      //     apidata=eval(apidata);
      //    console.log("apidatastatus"+typeof(response.data))
      if (apidata.Status == "Y") {
        if (apidata.Imgname == "") {
          apidata.Imgname = "Defaultimg.jpg";
        }
        dispatch(
          Success({
            Status: "Y",
            apiResponse: apidata.Imgname,
            Msg: "",
            accessid: AccessID,
            action: "get",
          }),
        );
      } else {
        dispatch(
          Success({
            Status: "Y",
            apiResponse: apidata.Imgname,
            Msg: "",
            accessid: AccessID,
            action: "get",
          }),
        );
      }
    })
    .catch((error) => {
      // dispatch(errored);
      dispatch(errored(error?.message));
      //dispatch(errored({"action":Action,"Status":apidata.Status,"apiResponse":apidata.Data,"Msg":""}))
    });
};

export const fnImageUpload =
  (formData, id, accessid) => async (dispatch, getState) => {
    var url = store.getState().globalurl.imgUploadUrl;

    console.log("--" + url);
    console.log(formData);
    dispatch(pending());
    axios
      .post(url, formData, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4MTA0OTV9.y3Bq2I7MMJLevEIVzb7m6UIirv86uvhoCBbb5qxF3lk",
        },
      })

      .then((response) => {
        console.log(response.data.Msg + "--" + response.data.name);
        toast.success("Image uploaded Sucessfully");
        dispatch(
          Success({
            Status: "Y",
            apiResponse: response.data.name,
            Msg: response.data.Msg,
            accessid: accessid,
          }),
        );

        var uploadImgurl = store.getState().globalurl.imageNameUpdateUrl;
        var imgData = {
          Recordid: id,
          ImageName: response.data.name,
          accessid: accessid,
          Action: "post",
        };

        axios
          .post(uploadImgurl, imgData, {
            headers: {
              Authorization:
                "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5Njc3NTN9.qtpn_hA0J4cbo56pfT4rVjPx0T6LaAzQznOiFQP3cyc",
            },
          })

          .then((imgresponse) => {
            console.log("--" + JSON.stringify(imgresponse));
          })
          .catch((error) => {
            // dispatch(errored);
            dispatch(errored(error?.message));
          });
      })
      .catch((error) => {
        // dispatch(errored);
        dispatch(errored(error?.message));
      });
  };

export function fnFileUpload(formData, id, accessid) {
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + JSON.stringify(success.data));
      toast.success(success.data.Msg || "Document Uploaded Sucessfully");

      const datawait = dispatch(
        Success({
          Status: "Y",
          apiResponse: success.data.name,
          Msg: success.data.Msg,
          accessid: accessid,
        }),
      );
      var uploadImgurl = store.getState().globalurl.imageNameUpdateUrl;
      var imgData = {
        Recordid: id,
        ImageName: success.data.name,
        accessid: accessid,
        Action: "post", //AS PER BACKEND TEAM REQUEST - ADDED "post" STRING FOR FILE UPLOAD TOO (PARKAVI AKKA - 09/01/2025)
      };

      axios
        .post(uploadImgurl, imgData, {
          headers: {
            Authorization:
              "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5Njc3NTN9.qtpn_hA0J4cbo56pfT4rVjPx0T6LaAzQznOiFQP3cyc",
          },
        })

        .then((imgresponse) => {
          console.log("--" + JSON.stringify(imgresponse));
        })
        .catch((error) => {
          // dispatch(errored);
          dispatch(errored(error?.message));
        });
      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.fileUploadUrl;

      dispatch(pending());

      const success = await axios.post(url, formData, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4MTA0OTV9.y3Bq2I7MMJLevEIVzb7m6UIirv86uvhoCBbb5qxF3lk",
        },
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}
export function fnCsvFileUploadnew(formData) {
  return async (dispatch) => {
    try {
      const url = store.getState().globalurl.csvUploadUrl;

      dispatch(pending());

      const success = await axios.post(url, formData, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4MTA0OTV9.y3Bq2I7MMJLevEIVzb7m6UIirv86uvhoCBbb5qxF3lk",
        },
      });

      // Simulate success payload structure
      const result = {
        Status: "Y",
        apiResponse: success.data.name, // Ensure 'name' is part of the response
        Msg: success.data.Msg,
      };

      // Dispatch success action
      dispatch(Success(result));

      // Return the result to the caller
      return { payload: result };
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error; // Re-throw error for the caller
    }
  };
}
export function fnCsvFileUpload(formData) {
  console.log("🚀 ~ fnCsvFileUpload ~ formData:", JSON.stringify(formData));
  return async (dispatch) => {
    function onSuccess(success) {
      console.log("2---" + JSON.stringify(success.data));
      toast.success("Document uploaded Sucessfully");

      const datawait = dispatch(
        Success({
          Status: "Y",
          apiResponse: success.data.name,
          Msg: success.data.Msg,
        }),
      );

      return datawait;
    }
    function onError(error) {
      //dispatch({ type: ERROR_GENERATED, error });
      return error;
    }
    try {
      var url = store.getState().globalurl.csvUploadUrl;

      dispatch(pending());

      const success = await axios.post(url, formData, {
        headers: {
          Authorization:
            "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4MTA0OTV9.y3Bq2I7MMJLevEIVzb7m6UIirv86uvhoCBbb5qxF3lk",
        },
      });
      return onSuccess(success);
    } catch (error) {
      return onError(error);
    }
  };
}

// // designationImport.js
// export function fnDesignationImport(formData) {
//   return async (dispatch) => {
//     try {
//       dispatch(pending());

//       //const baseUrl = store.getState().globalurl.designationImportUrl;

//       const file = formData.get("file");
//       const fileName = file?.name;

//        const url = `https://essuat.beyondexs.com?filename=${encodeURIComponent(fileName)}`;

//       const response = await axios.post(url, formData, {
//         headers: {
//           Authorization: "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk4MTA0OTV9.y3Bq2I7MMJLevEIVzb7m6UIirv86uvhoCBbb5qxF3lk",
//         },
//       });

//       dispatch(
//         Success({
//           Status: "Y",
//           apiResponse: response.data,
//           Msg: response.data?.Msg,
//         })
//       );

//       toast.success(response.data?.Msg || "Import successful");
//       return response;
//     } catch (error) {
//       dispatch(
//         Error({
//           Status: "N",
//           Msg: error.message,
//         })
//       );

//       toast.error("Import failed");
//       throw error;
//     }
//   };
// }
export const SOPfileUpload = createAsyncThunk(
  "Image/Finance Entry",
  async ({ formData }) => {
    console.log("🚀 ~ file: Imguploadreducer.js:19 ~ formData:", formData);
    const url = store.getState().globalurl.SOPAttachmentsController;
    const response = await axios.post(url, formData, {
      headers: {
        Authorization:
          "eyJhbGciOiJIUzI1NiIsInR5cGUiOiJKV1QifQ.eyJzdWIiOiJCZXhAMTIzIiwibmFtZSI6IkJleCIsImFkbWluIjp0cnVlLCJleHAiOjE2Njk5ODQzNDl9.uxE3r3X4lqV_WKrRKRPXd-Jub9BnVcCXqCtLL4I0fpU",
      },
    });
    console.log("🚀 ~ file: Imguploadreducer.js:26 ~ response:", response);
    return response.data;
  },
);
